var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LiveChat',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDisplayed),expression:"isDisplayed"}],ref:"liveChat",attrs:{"is-headless":"","token-object-id":_vm.eventId,"type":_vm.type,"data-test-id":"side-panel-chat"},on:{"messageAdded":_vm.onNewEntry}})
}
var staticRenderFns = []

export { render, staticRenderFns }